import React from 'react';
import { Box } from '@mui/material';

const Logo = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }}
    >
      {/* Logo Image */}
      <Box
        sx={{
          width: 48,
          height: 48,
          backgroundImage: 'url(/mfr-logo.png)',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          filter: 'drop-shadow(0 0 10px rgba(0, 255, 0, 0.5))',
          imageRendering: 'pixelated'
        }}
      />
      
      {/* Text */}
      <Box>
        <Box
          sx={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: '#00ff00',
            fontFamily: 'monospace',
            textShadow: '0 0 10px rgba(0, 255, 0, 0.5)',
            lineHeight: 1
          }}
        >
          MEME FR
        </Box>
        <Box
          sx={{
            fontSize: '0.8rem',
            color: '#888',
            fontFamily: 'monospace',
            letterSpacing: '2px'
          }}
        >
          $MFR
        </Box>
      </Box>
    </Box>
  );
};

export default Logo;
